import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { UserService } from '../../shared/services/user.service';

export const offerListGuard: CanActivateFn = (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const { user } = inject(UserService);
	return user.hasService('EOFFR') && !state.url.includes('draft');
};
